import httpService from "../../../services/httpService";
import { showErrorToast } from "V2.0/utils";
import { addToMCubeWhatsAppThread } from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/service";

export function useWhatsappSend() {
  const sendWhatsappMessage = async (
    projectId,
    assistantId,
    data,
    onSuccess
  ) => {
    try {
      const response = await httpService.post(
        `/whatsapp/manage/whitelabelAddToWhatsAppThread/${projectId}/${assistantId}`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccess();
      }
    } catch (e) {
      showErrorToast(e, "Failed to send message");
    }
  };

    const sendMCubeEngageWhatsappMessage = async function (
    workspaceId,
    assistantId,
    data,
    onSuccess,
  ) {
    const params = { workspaceId, assistantId };
    const body = { toNumber: data.toNumber, message: data.message };

    try {
      const request = { params, body };
      const response = await addToMCubeWhatsAppThread(request);

      if (response.status === 200) onSuccess();
    } catch (e) {
      showErrorToast(e, "Failed to send message");
    }
  };

  return { sendWhatsappMessage, sendMCubeEngageWhatsappMessage };
}
